var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H14C14.5523 0 15 0.447715 15 1V7C15 7.55228 14.5523 8 14 8C13.4477 8 13 7.55228 13 7V3C13 2.44772 12.5523 2 12 2H3C2.44772 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H12C12.5523 20 13 19.5523 13 19V16C13 15.4477 13.4477 15 14 15C14.5523 15 15 15.4477 15 16V21C15 21.5523 14.5523 22 14 22H1C0.447715 22 0 21.5523 0 21V1Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5C4 10.9477 4.44772 10.5 5 10.5H17.7C17.8657 10.5 18 10.3657 18 10.2V7.67361C18 7.41388 18.3076 7.27687 18.5007 7.45062L22.7522 11.277C22.8846 11.3962 22.8846 11.6038 22.7522 11.723L18.5007 15.5494C18.3076 15.7231 18 15.5861 18 15.3264V12.8C18 12.6343 17.8657 12.5 17.7 12.5H5C4.44772 12.5 4 12.0523 4 11.5Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exit.8fb7f898.svg";
export { ForwardRef as ReactComponent };